import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Tab, Tabs } from '@blueprintjs/core';
import { Tooltip2, Classes } from '@blueprintjs/popover2';

import RealByCorpus from './RealByCorpus';
import RealGlobal from './RealGlobal';

const extractRealSpec = (stats,subCorpora) => {
  var realSpec={};
  const realizations=Object.keys(stats.realizations).sort();
  for (var i=0;i<realizations.length;i++) {
    const realization=realizations[i];
    realSpec[realization]={};
    for (var j=0;j<subCorpora.length;j++) {
      const subCorpus=subCorpora[j];
      //console.log(realization+" "+subCorpus);
      if (stats.byCorpus[subCorpus] && stats.byCorpus[subCorpus]['realizations'] && stats.byCorpus[subCorpus]['realizations'][realization]) {
        realSpec[realization][subCorpus]=stats.byCorpus[subCorpus]['realizations'][realization]['spec'];
        //console.log(realization+" "+subCorpus+"="+toString(stats.byCorpus[subCorpus]['realizations'][realization]['spec']))
      }
    }
  }
  
  return realSpec;
}


class Realizations extends React.PureComponent {

  state = {
    //selectedTabId: Object.keys(this.props.stats.byCorpus)[0],  // select first corpus by default
    selectedTabId:Object.keys(this.props.stats.byCorpus).length===1? Object.keys(this.props.stats.byCorpus)[0]:"Global"
  }

  handleTabChange = (navbarTabId) => {
    this.setState({ selectedTabId: navbarTabId });
    // this trick is to cope with the react-apex-chart show problem
    // cdhttps://github.com/apexcharts/vue-apexcharts/issues/185
    window.dispatchEvent(new Event('resize'));
 
  }

  
  render() {
    const { stats, t, subCorpora } = this.props;

    const tabs = [];

    // grouping realization specificities in a single hash
    const realSpec=extractRealSpec(this.props.stats,subCorpora);

    // generate the global page, only when more than one page
    if (Object.keys(stats.byCorpus).length > 1) {
      const stat = <RealGlobal 
                      corpusStats={this.props.stats} 
                      realSpec={realSpec} 
                      estimatedResults={this.props.estimatedResults["_global_"]}
                    />;
      const tab = <Tab key='Global' id='Global' title={t('global')} panel={stat} />;
      tabs.push(tab);
    } else {
      // when there is only one page, some data should be copied from the global stats to the subCorpus
      stats.byCorpus[subCorpora[0]].realizations=stats.realizations;
    }

    // generate the indidual stat pages (sub-corpus or partition)
    const displayName=subCorpora.length>16;
    for (var i=0;i<subCorpora.length;i++) {
      const subCorpus=subCorpora[i];
      if (stats.byCorpus[subCorpus].freq) {
        const title=(displayName) ? (" "+(i+1).toString()).slice(-2):subCorpus;
        const detailStats="freqByReal";
        const stat =  <RealByCorpus 
                          name={subCorpus}
                          displayName={displayName}
                          corpusStats={stats.byCorpus[subCorpus]} 
                          realSpec={realSpec} 
                          detailStats={detailStats}
                          estimatedResults={this.props.estimatedResults[subCorpus]}
                      />;
        const tab = <Tab key={subCorpus} id={subCorpus} title={title} panel={stat} >
                      {displayName && <Tooltip2 content={subCorpus} className={Classes.TOOLTIP2_INDICATOR} placement="bottom" >…</Tooltip2>}
                    </Tab>;
        tabs.push(tab);
      }
    }

    return (
      <>
        <Tabs onChange={this.handleTabChange} selectedTabId={this.state.selectedTabId} renderActiveTabPanelOnly >
          {tabs}
        </Tabs>
      </>
    );
  }
}

Realizations.propTypes = {
  subCorpora:PropTypes.array,
  stats: PropTypes.object,
  estimatedResults: PropTypes.object,
};

export default withTranslation()(Realizations);
